import SwitchContentComponent from './components/switch-content';

const moduleName = 'app.massia.common.form.components';

angular.module(moduleName, []).component('switchContent', SwitchContentComponent);

export default moduleName;
